const OMS = '@oms';

export const GET_OMS_CONTROL_RECORDS = `${OMS}/GET_OMS_CONTROL_RECORDS`;
export const SET_OMS_CONTROL_RECORDS = `${OMS}/SET_OMS_CONTROL_RECORDS`;
export const GET_ERROR_OMS_CONTROL_RECORDS = `${OMS}/GET_ERROR_CONTROL_RECORDS`;


export const ASSIGN_WAVE_TO_CONTROL_RECORD = `${OMS}/ASSIGN_WAVE_TO_CONTROL_RECORD`;

export const SAVE_CONTROL_RECORDS = `${OMS}/SAVE_CONTROL_RECORDS`;
export const SHIPPED_CONTROL_RECORDS = `${OMS}/SHIPPED_CONTROL_RECORDS`;
export const PICKEDUP_CONTROL_RECORDS = `${OMS}/PICKEDUP_CONTROL_RECORDS`;

export const BOOK_SHIPPING_CONTROL_RECORD = `${OMS}/BOOK_SHIPPING_CONTROL_RECORD`;
export const BOOK_SHIPPING_DONE_CONTROL_RECORD = `${OMS}/BOOK_SHIPPING_DONE_CONTROL_RECORD`;
export const BOOK_SHIPPING_ERROR_CONTROL_RECORD = `${OMS}/BOOK_SHIPPING_ERROR_CONTROL_RECORD`;
export const BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD = `${OMS}/BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD`;
export const CANCEL_BOOK_SHIPPING_CONTROL_RECORD = `${OMS}/CANCEL_BOOK_SHIPPING_CONTROL_RECORD`;
export const CANCEL_BOOK_SHIPPING_DONE_CONTROL_RECORD = `${OMS}/CANCEL_BOOK_SHIPPING_DONE_CONTROL_RECORD`;
export const CANCEL_BOOK_SHIPPING_ERROR_CONTROL_RECORD = `${OMS}/CANCEL_BOOK_SHIPPING_ERROR_CONTROL_RECORD`;
export const CANCEL_BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD = `${OMS}/CANCEL_BOOK_SHIPPING_IN_PROGRESS_CONTROL_RECORD`;

export const REALLOCATE_CONTROL_RECORD = `${OMS}/REALLOCATE_CONTROL_RECORD`;
export const HOLD_CONTROL_RECORD = `${OMS}/HOLD_CONTROL_RECORD`;

export const PRINT_CONTROL_RECORD = `${OMS}/PRINT_CONTROL_RECORD`;
export const PRINT_CONTROL_RECORD_IN_PROGRESS = `${OMS}/PRINT_CONTROL_RECORD_IN_PROGRESS`;
export const PRINT_CONTROL_RECORD_ERROR = `${OMS}/PRINT_CONTROL_RECORD_ERROR`;
export const PRINT_CONTROL_RECORD_DONE = `${OMS}/PRINT_CONTROL_RECORD_DONE`;
export const PRINT_CONTROL_RECORD_ERROR_CLEAR = `${OMS}/PRINT_CONTROL_RECORD_ERROR_CLEAR`;
export const UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE = `${OMS}/UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE`;
export const UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS = `${OMS}/UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS`;
export const UPDATE_CONTROL_RECORDS = `${OMS}/UPDATE_CONTROL_RECORDS`;